import React, { useEffect, useState } from "react";
import { countRoomData, getCurrentUser } from "../../api-config/config";
import moment from "moment";

interface HotelStatusProps {
  startDate: Date;
  endDate: Date;
}

const HotelStatus: React.FC<HotelStatusProps> = ({ startDate, endDate }) => {
  const [totalRooms, setTotalRooms] = useState(0);
  const [occupiedRooms, setOccupiedRooms] = useState(0);
  const [expectedArrivals, setExpectedArrivals] = useState(0);
  const [expectedDepartures, setExpectedDepartures] = useState(0);
  const [roomsToSell, setRoomsToSell] = useState(0);
  const [eodProjection, setEodProjection] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const loggedUser = getCurrentUser();
        const hotelCode = loggedUser?.hotel_code;

        // Fetch total rooms and expected arrivals
        const roomResponse = await countRoomData({
          hotel_code: hotelCode,
          start_date: moment(startDate).format("YYYY-MM-DD"),
          end_date: moment(endDate).format("YYYY-MM-DD"),
        });

        if (roomResponse?.status_message === "success") {
          setTotalRooms(roomResponse.total_rooms || 0);
          setOccupiedRooms(roomResponse.occupied_rooms || 0);
          setExpectedArrivals(roomResponse.expected_arrival || 0);
          setExpectedDepartures(roomResponse.expected_departure || 0);
          setRoomsToSell(roomResponse.rooms_to_sell || 0);
          setEodProjection(0);
        } else {
          console.error("Failed to fetch room data:", roomResponse.message);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [startDate, endDate]); // Re-fetch data when startDate or endDate changes

  const data = [
    { totalroom: "Totalroom", totalcount: totalRooms },
    { totalroom: "Occupied", totalcount: occupiedRooms },
    { totalroom: "Expected Arrivals", totalcount: expectedArrivals },
    { totalroom: "Expected Departures", totalcount: expectedDepartures },
    { totalroom: "Rooms to Sell", totalcount: roomsToSell },
    // { totalroom: "EOD Projection", totalcount: eodProjection },
  ];

  return (
    <>
      <div>
        <div className="hotelstatus-cont">HotelStatus</div>
        <div className="hotelstatus-main-cont px-2">
          {data.map((data, index) => (
            <div
              key={index}
              className="hotel-status-mapdata flex justify-between"
            >
              <p>{data.totalroom}</p>
              <p>{data.totalcount}</p>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default HotelStatus;
